import type {
  OnBoardingStep4Query,
  UpdateUsersPermissionsUserMutation,
} from '@edwin-group/cj-graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';

import requestHandler from '../requestHandler';

import { MUTATION_UPDATE_USER_WEEKLY, MUTATION_UPDATE_USER, QUERY_ONBOARDING_STEP4 } from '@edwin-group/cj-graphql';

export async function fetchOnBoardingStep4() {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<OnBoardingStep4Query>({
      query: QUERY_ONBOARDING_STEP4,
    }),
  );

  return data?.step4?.data?.attributes;
}

export async function updateProfile(id: string, profile: string, gender: string, location: string, ageBracket: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input: {
          profile,
          gender,
          location,
          ageBracket,
        },
      },
    }),
  );
  return data;
}

export async function onCompletedOnBoarding(id: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input: {
          onboardHomeCompleted: true,
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}

export async function onInitOnBoarding(id: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input: {
          onboardingStartDate: new Date().toISOString().split('T')[0],
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}

export async function onCompletedOnBoardingWeeklyQuestion(id: string) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate<UpdateUsersPermissionsUserMutation>({
      mutation: MUTATION_UPDATE_USER_WEEKLY,
      variables: {
        id,
        input: {
          onboardQuestionsCompleted: true,
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}
